export default {
  // Hero section
  'hero.title': 'Outils de Minuterie en Ligne Professionnels',
  'hero.subtitle': 'Choisissez l\'outil de chronométrage parfait pour vos besoins',

  // Tool cards
  'timer.title': 'Minuteur',
  'timer.description': 'Minuteur inversé pour le travail, les études et la vie',
  'timer.longDescription': 'Minuteur inversé pour la productivité, la cuisine et la gestion du temps',
  'timer.button': 'Démarrer le Minuteur',

  'stopwatch.title': 'Chronomètre',
  'stopwatch.description': 'Outil de chronométrage haute précision',
  'stopwatch.longDescription': 'Chronomètre haute précision pour le sport, l\'entraînement et le chronométrage précis',
  'stopwatch.button': 'Démarrer le Chronomètre',

  'worldclock.title': 'Horloge Mondiale',
  'worldclock.description': 'Voir les fuseaux horaires du monde entier',
  'worldclock.longDescription': 'Affichage en temps réel des heures des principales villes du monde avec des calculs intelligents de fuseaux horaires',
  'worldclock.button': 'Voir l\'Horloge Mondiale',

  // Features section
  'features.title': 'Pourquoi Choisir timer.today?',
  'features.reliable.title': 'Fiable et Précis',
  'features.reliable.desc': 'Chronométrage de précision à la milliseconde avec fiabilité basée sur le navigateur',
  'features.crossPlatform.title': 'Multiplateforme',
  'features.crossPlatform.desc': 'Fonctionne parfaitement sur ordinateur de bureau, tablette et appareils mobiles',
  'features.smartNotifications.title': 'Notifications Intelligentes',
  'features.smartNotifications.desc': 'Alertes sonores et notifications de bureau lorsque le temps est écoulé',
  'features.easyToUse.title': 'Facile à Utiliser',
  'features.easyToUse.desc': 'Interface épurée avec commandes intuitives pour tous les utilisateurs',

  // Keywords section
  'keywords.timer': 'minuteur compte à rebours pomodoro concentration travail pause',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};
